<template>
  <div class="footer container-fluid">
    <div class="footer-row">
      <span class="powered">中国人民大学中国调查与数据中心版权所有</span>

      <!-- <div class="logo">
        <a href="https://www.omnidataware.com" target="_blank">
          <img src="../assets/images/logo-omni.png" />
        </a>
      </div> -->

      <span class="copy">
        <!-- <a href="https://www.omnidataware.com" target="_blank">奥秘维数据科技（北京）有限公司技术支持</a> -->
        <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025146215号-9</a>
      </span>
      <!-- <div class="contact hidden-xs">
        <template v-for="(item, i) in list">
          <img :src="item.icon" @mouseleave="hideQrCode" @mouseover="showQrCode(item)" />
        </template>
</div> -->

      <!-- <div class="qrcode" v-show="show" :style="{ 'right': right + 'px' }">
        <img :src="qrcode" />
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "LsFooter",
  data() {
    return {
      list: [
        { icon: require("@/assets/images/weibo.png"), code: require("@/assets/qrcodes/4_Omnidataware_blog.png"), right: 93 },
        { icon: require("@/assets/images/wechat.png"), code: require("@/assets/qrcodes/3_Omnidataware_officialaccount.jpg"), right: 29 },
        { icon: require("@/assets/images/contact.png"), code: require("@/assets/qrcodes/1_Contact.png"), right: -29 },
      ],
      show: false,
      right: 0,
      qrcode: null
    }
  },
  mounted() {

  },
  methods: {
    showQrCode(record) {
      this.qrcode = record.code
      this.right = record.right
      this.show = true
    },
    hideQrCode() {
      this.show = false;
    }

  }
}
</script>
<style scoped>
.footer {
  height: 85px;
  background: rgba(0, 0, 0, 0.4);
  ;
}

.footer .footer-row {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-row .logo {
  padding: 0px 16px;
}

.footer-row .powered {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
}

.footer-row .copy {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  margin-left: 8px;
}

.footer-row .copy a {
  color: #FFFFFF;
}

.footer-row .contact {
  height: 100%;
  display: flex;
  align-items: center;
}

.footer-row .contact img {
  margin-left: 20px;
  cursor: pointer;
}

.footer-row .qrcode {
  position: absolute;
  bottom: 68px;
  width: 132px;
  height: 140px;
  background: url(../assets/images/bg-code.png);
  background-size: 100% 100%;
  z-index: 99;
  padding: 5px 5px 12px;
}

.qrcode img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/LsFooter.vue